export enum EnrollmentTypes {
    cancel = "cancel",
    makeUp = "makeUp",
    single = "single"
}